export default __webpack_public_path__ + "static/media/map.4dea19b1.webp";